import React from 'react';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import { DownloadDesktopApp } from '@/views/Onboarding/components/DownloadDesktopApp.component';
import styles from './DownloadDesktopAppPage.module.scss';

export const DownloadDesktopAppPageComponent = () => {
  return (
    <div className={styles.downloadDesktopAppPage}>
      <Text
        variant={textVariantsEnum.Header}
        fontWeight={fontWeightEnum.Semibold}
      >
        Download Desktop App
      </Text>
      <p className={`mt-2 mb-0 ${styles.muted}`}>
        Download the desktop app to track your time and attendance.
      </p>
      <div className={styles.panel}>
        <DownloadDesktopApp hideHeading />
      </div>
    </div>
  );
};
